<template>
    <div v-if="isLoading" class="d-flex justify-content-center">
        <b-spinner class="align-middle" variant="secondary" />
    </div>
    <div v-else-if="reflections.length>0">
        <reflection-card
            v-for="reflection in reflections"
            :key="reflection.id"
            :breadcrumbs="reflectionsPars.serviceType=='program' ?
                            reflection.programName + ' / ' + reflection.moduleName + ' / ' + reflection.chapterName
                            :reflectionsPars.serviceType=='stream' ? reflection.programName: ''"
            :title="reflection.question"
            :text="reflection.answer"
            :date="dateFormat(reflection.date)"
            @goToPage="goToPage(reflection.link)"
        >
        <div v-if="reflection.exercise" class="mb-3">
            <WordHunterResultsContainer
                :selectedTopicId="reflection.exercise.selectedTopic.topicId"
                :topicList="reflection.exercise.topicList.topics"
                :selectedWords="reflection.exercise.selectedWords"
            />
        </div>
        </reflection-card>

        <div v-if="isLoadingMore" class="d-flex justify-content-center h-100 align-items-center mt-5">
            <b-spinner class="align-middle" variant="secondary" />
        </div>
        <div v-else-if="reflectionsPars.currentPage !== reflectionsPars.lastPage"
            @click="loadMoreReflections()"
            class="text-primary text-bold d-flex justify-content-center mt-5"
        >
            <b-link class="btn text-primary">{{trans('journal.reflections.show_more')}}</b-link>
        </div>
    </div>
    <div v-else class="text-center">
        <b-img src="/images/journal/reflections_search_empty.svg" />
        <p class="">{{trans('journal.reflections.empty_search.p1')}}</p>
        <b-button
            variant="secondary"
            class="font-weight-bold"
            @click="resetFilters"
        >
            {{ trans("journal.reflections.empty_search.button") }}
        </b-button>
    </div>
</template>

<script>
    import roleMixin from '../../mixins/roleMixin';
    import { mapGetters, mapMutations, mapActions } from 'vuex';
    import ReflectionCard from '../../molecules/cards/ReflectionCard';
    import WordHunterResultsContainer from '../word-hunter/WordHunterResultsContainer'

    export default {
        name: "JournalReflectionsContent",
        components: { ReflectionCard, WordHunterResultsContainer },
        computed: {
            ...mapGetters({
                isLoading: 'journal/getReflectionsLoading',
                isLoadingMore: 'journal/getReflectionsLoadingMore',
                reflections: 'journal/getReflections',
                reflectionsPars: 'journal/getReflectionsPars',
            })
        },
        methods: {
            ...mapActions({
                loadMoodsList: 'moodsAndReactions/loadMoodsList'
            }),
            loadMoreReflections(){
                this.$emit('loadMoreReflections');
            },
            resetFilters(){
                this.$emit('resetFilters');
            },
            goToPage(link){
                trackEvent('JournalReflectionCheckPage', {
                    link: link
                })

                this.$router.push(link);
            },
            dateFormat(date) {
                let dateSplitted = date.split(' ')[0].split('-');
                return dateSplitted[2] + '/' + dateSplitted[1] + '/' + dateSplitted[0];
            }
        },
        mounted() {
            this.loadMoodsList();
        },
        mixins: [roleMixin]
    }
</script>
